import { CLEAR_RECEIPT } from '../Accounting/ReceiptValidation/ReceiptValidationReducer'

export const SET_WORKFLOW_OPTIONS = 'SET_WORKFLOW_OPTIONS'
export const SET_ENTITY_TYPE_DROPDOWN_OPTIONS = 'SET_ENTITY_TYPE_DROPDOWN_OPTIONS'
export const SET_ENTITY_SUBTYPE_DROPDOWN_OPTIONS = 'SET_ENTITY_SUBTYPE_DROPDOWN_OPTIONS'
export const SET_SELECTED_ROW = 'SET_SELECTED_ROW'
export const SET_EXISTING_NAME_FOUND = 'SET_EXISTING_NAME_FOUND'
export const SET_NAME_SEARCH_RESULTS = 'SET_NAME_SEARCH_RESULTS'
export const SET_NUMBER_SEARCH_RESULTS = 'SET_NUMBER_SEARCH_RESULTS'
export const SET_UCC_RECORD_OPTIONS = 'SET_UCC_RECORD_OPTIONS'
export const SET_BUSSINESS_CERT_FORM_OPTIONS = 'SET_BUSSINESS_CERT_FORM_OPTIONS'
export const SET_TRADEMARK_TYPE_OPTIONS = 'SET_TRADEMARK_TYPE_OPTIONS'
export const SET_NOTARY_OPTIONS = 'SET_NOTARY_OPTIONS'
export const SET_REGISTERED_AGENT_OPTIONS = 'SET_REGISTERED_AGENT_OPTIONS'
export const SET_WORKVIEW_ITEMS_UNPAGINATED = 'SET_WORKVIEW_ITEMS_UNPAGINATED'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const SET_SELECTED_FILING = 'SET_SELECTED_FILING'
export const SET_SELECTED_FORM = 'SET_SELECTED_FORM'
export const SET_FILING_SEARCH = 'SET_FILING_SEARCH'
export const SET_FILING_TYPE_CODES = 'SET_FILING_TYPE_CODES'
export const SET_CORRESPONDENCE_AMENDMENT_OPTIONS = 'SET_CORRESPONDENCE_AMENDMENT_OPTIONS'
export const SET_CORRESPONDENCE_SOURCE_TYPE_OPTIONS = 'SET_CORRESPONDENCE_SOURCE_TYPE_OPTIONS'
export const SET_WORKVIEW_CATEGORY_USERS = 'SET_WORKVIEW_CATEGORY_USERS'
export const BULK_ASSIGN_LIST_REFRESH = 'BULK_ASSIGN_LIST_REFRESH'
export const SET_AMENDMENT_WIZARDS = 'SET_AMENDMENT_WIZARDS'
export const SET_NEEDS_ENTITY = 'SET_NEEDS_ENTITY'
export const SET_MY_ASSIGNED_CHECKED = 'SET_MY_ASSIGNED_CHECKED'
export const SET_UNASSIGNED_CHECKED = 'SET_UNASSIGNED_CHECKED'
export const SET_PAPER_REDIRECT = 'SET_PAPER_REDIRECT'
export const SET_CORRESPONDENCE_INFO = 'SET_CORRESPONDENCE_INFO'
export const SET_STAFF_DRAFT = 'SET_STAFF_DRAFT'
export const SET_STAFF_FILING_CORRECTION_INFO = 'SET_STAFF_FILING_CORRECTION_INFO'
export const SET_LOADING_AMENDMENT_WIZARDS = 'SET_LOADING_AMENDMENT_WIZARDS'
export const SET_PAPER_FILING_ERROR_MESSAGE = 'SET_PAPER_FILING_ERROR_MESSAGE'

export const defaultFilingSearchQuery = {
  QueryTypeID: '1',
  QueryID: '1',
  SearchMethodID: '1',
  Method: '1',
  PageNumber: '1',
  PageSize: '2500',
  QueryTypeId: '1',
}

export const initialState = {
  activeCategoryId: 0,
  myAssignedChecked: false,
  unassignedChecked: false,
  error: false,
  errorDetails: {
    code: null,
    message: null,
  },
  items: [],
  selected: {},
  users: null,
  sidebarCollapsed: false,
  workflowOptions: [],
  amendmentWizards: [],
  entityTypeOptions: [],
  entitySubtypeOptions: [],
  correspondenceAmendmentOptions: {},
  correspondenceSourceTypeOptions: [],
  UCCRecordsOptions: [],
  businessCertFormOptions: [],
  trademarkTypeOptions: [],
  notaryFormOptions: [],
  registeredAgentFormOptions: [],
  selectedRow: {
    FilingTypeID: '',
    FilingSubTypeID: '',
    ReferenceName: '',
    SelectedFiling: null,
  },
  filingSearchQuery: defaultFilingSearchQuery,
  existingNameFound: false,
  showSearchError: false,
  currentUser: {},
  searchResults: [],
  filingTypeCodes: null,
  workviewCategoryUsers: [], //[{WorkViewID: 16, Category: "UCC Info Request", Users: [{Name: "Braden S", AppUserID: 1527}, {Name: "Theo", AppUserID: 11151}]}], //[],
  staffDraft: null,
  staffFilingCorrectionInfo: null,
  loadingAmendmentWizards: false,
  showPaperFilingErrorMessage: false,
}

const WorkviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_WORKVIEW_STATE':
      return initialState
    case 'SET_WORKVIEW_ITEMS':
      action.items.map((item, index) => {
        if (item.EntryType == null) {
          item.EntryType = 'Paper Filed'
          return item
        }
        return {
          item,
        }
      })
      return {
        ...state,
        items: [...state.items, ...action.items],
      }
    case SET_WORKVIEW_ITEMS_UNPAGINATED: {
      action.items.map((item) => {
        if (item.EntryType === null) {
          return {
            ...item,
            EntryType: 'Paper Filed',
          }
        }
        return {
          item,
        }
      })
      return {
        ...state,
        items: action.items,
      }
    }
    case 'SET_USERINFO_ITEMS':
      return {
        ...state,
        users: [...action.items],
      }
    case 'SET_CURRENT_USERINFO_ITEMS':
      return {
        ...state,
        currentUser: action.items,
      }
    case 'SET_CURRENT_USERINFO_ERROR':
      return {
        ...state,
        currentUser: action.items,
      }
    case 'SET_WORKVIEW_ITEM_HISTORY':
      return {
        ...state,
        itemHistory: { ...state.itemHistory },
      }
    case 'SET_WORKVIEW_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'SET_WORKVIEW_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails,
      }
    case 'SELECT_WORKVIEW_ITEM':
      return {
        ...state,
        selected: {
          [action.category]:
            state.selected[action.category] !== action.selected ? action.selected : null,
        },
      }
    case 'SET_WORKVIEW_ASSIGNMENT':
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (item.ID !== action.items.ID) {
            return item
          } else {
            action.items.EntryType = item.EntryType
            return {
              ...action.items,
            }
          }
        }),
      }
    case SET_LOADING_AMENDMENT_WIZARDS:
      return {
        ...state,
        loadingAmendmentWizards: action.loadingAmendmentWizards,
      }
    case SET_PAPER_FILING_ERROR_MESSAGE:
      return {
        ...state,
        paperFilingErrorMessage: action.paperFilingErrorMessage,
        showPaperFilingErrorMessage: action.paperFilingErrorMessage ? true : false,
      }
    case SET_STAFF_DRAFT:
      return {
        ...state,
        staffDraft: action.staffDraft,
      }
    case BULK_ASSIGN_LIST_REFRESH:
      return {
        ...state,
        items: state.items.map((item) => {
          const updateItem = action.items.find((update) => update.ID === item.ID)
          return updateItem ? updateItem : item
        }),
      }
    case '@@wv/SET_ACTIVE_CATEGORY':
      return { ...state, activeCategoryId: action.categoryId }
    case SET_MY_ASSIGNED_CHECKED:
      return { ...state, myAssignedChecked: action.myAssignedChecked }
    case SET_UNASSIGNED_CHECKED:
      return { ...state, unassignedChecked: action.unassignedChecked }
    case '@@wv/INVALIDATE_CACHE':
      return {
        ...state,
        selected: {},
        selectedDetails: null,
        selectedIndex: null,
      }
    case SET_WORKFLOW_OPTIONS: {
      return {
        ...state,
        workflowOptions: action.options,
      }
    }
    case SET_ENTITY_TYPE_DROPDOWN_OPTIONS: {
      return {
        ...state,
        entityTypeOptions: action.options,
      }
    }
    case SET_ENTITY_SUBTYPE_DROPDOWN_OPTIONS: {
      return {
        ...state,
        entitySubtypeOptions: action.options,
      }
    }
    case SET_UCC_RECORD_OPTIONS: {
      return {
        ...state,
        UCCRecordOptions: action.options,
      }
    }
    case SET_BUSSINESS_CERT_FORM_OPTIONS: {
      return {
        ...state,
        businessCertFormOptions: action.options,
      }
    }
    case SET_TRADEMARK_TYPE_OPTIONS: {
      return {
        ...state,
        trademarkTypeOptions: action.options,
      }
    }
    case SET_NOTARY_OPTIONS: {
      return {
        ...state,
        notaryFormOptions: action.options,
      }
    }
    case SET_REGISTERED_AGENT_OPTIONS: {
      return {
        ...state,
        registeredAgentFormOptions: action.options,
      }
    }

    case SET_SELECTED_ROW: {
      let filingTypeName = ''
      if (action.selectedRow.FilingTypeID) {
        const opt = state.entityTypeOptions.find(
          (op) => op.value === action.selectedRow.FilingTypeID
        )
        if (opt) filingTypeName = opt.label
      }
      return {
        ...state,
        selectedRow: {
          ...action.selectedRow,
          FilingTypeID: action.selectedRow.FilingTypeID || '',
          FilingType: filingTypeName,
          FilingSubTypeID: action.selectedRow.FilingSubTypeID || '',
          ReferenceName: action.selectedRow.ReferenceName || '',
          CertificationDetails: undefined,
          SelectedFiling: undefined,
          SelectedFormDefinitionId: undefined,
          SelectedFormAmendmentTypeId: undefined,
          SelectedFormFilingTypeId: undefined,
          paperRedirect: undefined,
        },
        existingNameFound: action.selectedRow.ImageDataTypeCategory !== 'Business Filings',
      }
    }
    case SET_PAPER_REDIRECT: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          paperRedirect: action.paperRedirect,
        },
      }
    }
    case SET_EXISTING_NAME_FOUND: {
      return {
        ...state,
        existingNameFound: action.existingNameFound,
      }
    }
    case SET_NAME_SEARCH_RESULTS: {
      return {
        ...state,
        searchResults: action.results,
        showSearchError: action.results.length === 0,
      }
    }
    case SET_NUMBER_SEARCH_RESULTS: {
      return {
        ...state,
        searchResults: action.results,
        showSearchError: action.results.length === 0,
      }
    }
    case CLEAR_RECEIPT: {
      if (action.fromCorrespondence) return state
      return {
        ...state,
        selectedRow: {
          FilingTypeID: '',
          FilingSubTypeID: '',
          ReferenceName: '',
        },
      }
    }
    case SET_SEARCH_RESULTS: {
      return {
        ...state,
        searchResults: action.results,
      }
    }
    case SET_SELECTED_FILING: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          SelectedFiling: action.filing,
        },
      }
    }
    case SET_SELECTED_FORM: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          SelectedFormStaffDraft: action.data.staffDraft,
          SelectedFormDefinitionId: action.data.formDefinitionID,
          SelectedFormAmendmentTypeId: action.data.amendmentTypeID,
          SelectedFormFilingTypeId: action.data.filingTypeID,
        },
      }
    }
    case SET_NEEDS_ENTITY: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          CertificationDetails: action.CertificationDetails,
        },
      }
    }
    case SET_FILING_SEARCH: {
      return {
        ...state,
        filingSearchQuery: action.query,
      }
    }
    case SET_FILING_TYPE_CODES: {
      return {
        ...state,
        filingTypeCodes: action.typeCodes,
      }
    }
    case SET_CORRESPONDENCE_AMENDMENT_OPTIONS: {
      return {
        ...state,
        correspondenceAmendmentOptions: {
          ...state.correspondenceAmendmentOptions,
          [action.sourceTypeID]: action.options,
        },
      }
    }
    case SET_CORRESPONDENCE_SOURCE_TYPE_OPTIONS: {
      return {
        ...state,
        correspondenceSourceTypeOptions: action.options,
      }
    }
    case SET_WORKVIEW_CATEGORY_USERS: {
      return {
        ...state,
        workviewCategoryUsers: action.workviewCategoryUsers,
      }
    }
    case SET_AMENDMENT_WIZARDS: {
      return {
        ...state,
        amendmentWizards: action.amendmentWizards,
      }
    }
    case SET_STAFF_FILING_CORRECTION_INFO: {
      return {
        ...state,
        staffFilingCorrectionInfo: action.staffFilingCorrectionInfo,
      }
    }
    default:
      return state
  }
}

export default WorkviewReducer
